import { Component, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuditComponent } from './audit.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ReportDetailComponent } from './report-detail/report-detail.component';

const routes: Routes = [
  {
    path: '', component: AuditComponent, children: [
      { path: '', redirectTo: 'audits', pathMatch: 'full' },
      { path: 'audits', component: DashboardComponent,title: 'On-page Audits | Strell.io' },
      { path: 'audit/:id', component: ReportDetailComponent,title: 'On-page Audits | Strell.io'},
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuditRoutingModule { }
